import React, { useState } from 'react'

import icons from '../assets/icons'
import { useIdleTimer } from 'react-idle-timer'
import { useTranslation } from 'react-i18next'

const TIME_INTERVAL = 10 * 60 * 1000

const BrandingLayer: React.FC = () => {
  const [visible, setVisible] = useState(true)
  const { t } = useTranslation()

  const showLayer = () => {
    setVisible(true)
  }

  const { start } = useIdleTimer({
    timeout: TIME_INTERVAL,
    onIdle: showLayer,
    startManually: true,
  })

  const onPressExplore = () => {
    start()
    setVisible(false)
  }

  if (visible) {
    return (
      <div className='branding'>
        <img
          src={icons.logo}
          width={150}
          height={30}
          alt='Logo Ponant'
          className='header--logo branding--logo'
        />
        <div className='branding--center'>
          <div>
            <img src={icons.earth} className='branding--earth' />
            <p className='branding--explore'>Explore</p>
          </div>

          {/* eslint-disable-next-line react/no-unescaped-entities */}
          <p className='text text--white text--lineHeight25 branding--text'>{t('branding.body')}</p>

          <div className='branding--button' onClick={onPressExplore}>
            {/* eslint-disable-next-line react/no-unescaped-entities */}
            <p className='text text--white text--size13 '>{t('branding.action')}</p>
          </div>
        </div>
      </div>
    )
  }
  return null
}

export default BrandingLayer
